export default {
	methods: {
		handleRequiredGroupChange() {
			const inputFields = document.querySelectorAll('.rwleadsl-checkbox__input-required');
			let values = [];
			for (let i = 0; i < inputFields.length; i++) {
				values.push(inputFields[i].checked);
			}

			const validValue = values.find((value) => value === true);
			this.requiredGroupInvalid = !validValue;
		},
		validate(errors) {
			for (let key in errors) {
				if (errors.hasOwnProperty(key)) {
					const errorsList = errors[key];

					errorsList.forEach((errorItem) => {
						errorItem.errors.forEach((error) => {
							this.formState[errorItem.field].$error[error] = true;
							this.formState[errorItem.field].$touched = true;
							this.formState[errorItem.field].$invalid = true;
							this.formState[errorItem.field].$valid = false;
						});
					});
				}
			}
		}
	}
};
